import { ApiImageClient } from "@/api";

async function apiUserUpload(data) {
  try {
    const result = await ApiImageClient.post(`/upload`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then(({ data }) => data);
    return result;
  } catch (e) {
    console.error("apiUserUpload_Error", e);
  }
}

export { apiUserUpload };
